import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LandingPageNavBar from '../../components/navbar/landingPage/LandingPageNavBar';
import HeroSection from '../../components/LandingPage/HeroSection';
import axios from 'axios';

const Hero = () => {
  const navigate = useNavigate();

  // State for inputs
  const [location, setLocation] = useState('');
  const [cities, setCities] = useState([]);
  const [error, setError] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);

  // Load the saved location from localStorage when the component mounts
  useEffect(() => {
    const savedLocation = localStorage.getItem('selectedLocation');
    if (savedLocation) {
      setLocation(savedLocation);
    }
  }, []);

  // Fetch cities from API
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API2_URL}/getavailablecities`);
        setCities(response.data.cities || []);
      } catch (err) {
        setError('Failed to fetch cities');
      }
    };

    fetchCities();
  }, []); 

  const handleLocationChange = (e) => {
    const selectedLocation = e.target.value;
    setLocation(selectedLocation);
    localStorage.setItem('selectedLocation', selectedLocation);
  };

  const handleBookNowClick = () => {
    if (!location) {
      alert('Please select a location');
      return;
    }
    setIsRedirecting(true);
    setTimeout(() => {
      navigate(`/explore/${location.toLowerCase()}`);
    }, 500);
  };

  return (
    <div className="flex flex-col justify-between h-screen">
      <LandingPageNavBar />
      <HeroSection
        location={location}
        onLocationChange={handleLocationChange}
        cities={cities}
        onBookNowClick={handleBookNowClick}
        isRedirecting={isRedirecting}
      />
    </div>
  );
};

export default Hero;
